import axios from 'axios';
import { API_BASE_URL } from '../config';

/**
 * Stores user authentication data in localStorage
 * @param {string} email - User email
 * @param {string} fullName - User full name
 */
export const storeUserData = (email, fullName) => {
  localStorage.setItem('userEmail', email);
  if (fullName) {
    localStorage.setItem('userName', fullName);
  }
};

/**
 * Login user with email and password
 * @param {string} email - User email
 * @param {string} password - User password
 * @returns {Promise} - API response with tokens and user data
 */
export const loginUser = async (email, password) => {
  const response = await axios.post(
    `${API_BASE_URL}/api/auth/login`,
    {
      email: email.toLowerCase(),
      password
    }
  );
  return response.data;
};

/**
 * Register new user
 * @param {Object} userData - User registration data
 * @param {string} userData.email - User email
 * @param {string} userData.password - User password
 * @param {string} userData.fullName - User full name
 * @param {string} userData.inviteCode - Invite code (optional)
 * @returns {Promise} - API response with tokens and user data
 */
export const registerUser = async ({ email, password, fullName, inviteCode = '' }) => {
  const response = await axios.post(
    `${API_BASE_URL}/api/auth/register`,
    {
      email: email.toLowerCase(),
      password,
      full_name: fullName,
      invite_code: inviteCode
    }
  );
  return response.data;
};

/**
 * Process auth response and store user data
 * @param {Object} authData - Auth response data
 * @param {Function} loginCallback - Login callback from AuthContext
 * @returns {Object} - Processed user data
 */
export const processAuthResponse = (authData, loginCallback) => {
  const {
    access_token,
    refresh_token,
    user_id,
    email,
    full_name,
    subscription_plan
  } = authData;

  // Store user data in localStorage
  storeUserData(email, full_name);

  // Update auth context
  const userData = {
    id: user_id,
    email,
    full_name,
    subscription_plan
  };

  loginCallback(access_token, refresh_token, userData);

  return userData;
};
